import { CustomScalarType8w7iuefxipic as CustomScalarType } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.k6m_1 = new (CustomScalarType())('Float', 'kotlin.Double');
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstancet6obscsk3i3d,
};
//endregion

//# sourceMappingURL=GraphQLFloat.mjs.map
